import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  min-width: auto;
  padding-right: ${({ right }) => right || ''};
  max-width: 100%;
  .ant-btn-primary {
    width: ${({ width }) => width || '135px'};
    height: ${({ height }) => height || '40px'};
    background: ${({ background }) =>
      background || 'linear-gradient(200deg, #6610f2 0%, #8B44FF 100%)'};
    border: ${({ border }) => border || 'none'};
    border-radius: ${({ borderRadius }) => borderRadius || '4px'};
    font-size: ${({ fontSize }) => fontSize || '16px'};
    line-height: 16px;
    color: ${({ color }) => color || ''};
    box-shadow: none;

    :hover {
      background: ${({ background }) =>
        background || 'linear-gradient(200deg, #6610f2 0%, #8B44FF 100%)'};
      color: ${({ color }) => color || ''};
      border: ${({ border }) => border || ''};
    }
  }
`;
